import injectSheet from 'react-jss'
import classNames from 'classnames'
import { useSelector, shallowEqual } from 'react-redux'
import CardIcon from '@/components/CardIcon'
import CarouselHTML from '@/components/CarouselHTML'
import DelayLink from '@/components/DelayLink'
import style from './style'

const FeaturedIconCards = ({
  className,
  classes,
  title,
  text,
  link,
  items,
}) => {
  const { mediaQueryKey } = useSelector((state) => ({
    mediaQueryKey: state.mediaQuery.key,
  }), shallowEqual)

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <div className={classes.intro}>
            {title && (
              <h2
                className={classes.title}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {text && (
              <div
                className={classes.text}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>
          <div className={classes.cardList}>
            <CarouselHTML
              centerMode={true}
              slidesToShow={mediaQueryKey > 1 ? 5 : 1}
              infinite={mediaQueryKey <= 1}
            >
              {items.map((item) => (
                <DelayLink
                  to={link}
                  className={classes.cardItem}
                  key={item.id}
                >
                  <CardIcon
                    icon={item.icon}
                    text={item.text}
                    background={item.background}
                    y={mediaQueryKey > 1 && item.y}
                    rotate={mediaQueryKey > 1 && item.rotate}
                  />
                </DelayLink>
              ))}
            </CarouselHTML>
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(FeaturedIconCards)
